import { Route, Routes } from 'react-router-dom';

import { useStateContext } from '../../contexts/ContextProvider';

import ConversationsFermees from './messagerie/ConversationsFermees';
import { EtatListeProvider } from './messagerie/EtatListeContext';
import FilConversation from './messagerie/FilConversation';
import ListeConversations from './messagerie/ListeConversations';

/**
 * L'écran « Messagerie » du registre, et son routage interne.
 *
 * Le registre de #75 ne connaît qu'un chemin par écran (`/messaging`) et monte un
 * seul composant derrière `/*`. Les sous-chemins appartiennent donc à l'écran
 * lui-même — c'est déjà ce que `useEcrans().estEligible` suppose en rattachant
 * `/messaging/42` à la messagerie : une notification ouvre une conversation
 * précise, et la garde ne doit pas lui refuser l'écran dont elle vient.
 */
export default function Messagerie() {
    const { currentFacility } = useStateContext();
    // La clé remonte la liste à neuf quand l'établissement change (#25).
    const cleEtablissement = String(currentFacility?.id ?? 'aucun');

    return (
        <EtatListeProvider>
            <Routes>
                <Route index element={<ListeConversations key={cleEtablissement} />} />
                {/*
                 * Déclarée avant `:id` par lisibilité seulement — vérifié en inversant
                 * l'ordre : React Router v6 classe les routes par SPÉCIFICITÉ, et un
                 * segment statique bat toujours un segment dynamique. « closed » ne peut
                 * donc pas être lu comme un identifiant de client, quel que soit l'ordre.
                 */}
                <Route path="closed" element={<ConversationsFermees key={cleEtablissement} />} />
                <Route path=":id" element={<FilConversation />} />
            </Routes>
        </EtatListeProvider>
    );
}
